module.exports = __webpack_public_path__ + "main/assets/public/rrr-50/rrr-vertical-reverse.4f3d5bdec7b060a0.svg";